<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <b-card style="border: none; margin-left: 2rem; margin-right: 2rem; margin-top: 2rem; margin-bottom: 0">
            <div  v-if="!isExtern">
                <b-row>
                    <b-col>
                      <label v-if="hasExternalEmail" for="email">E-Mail für Rückmeldungen</label>
                      <b-form-input v-if="hasExternalEmail" id="email" type="text"
                                    v-model="email"
                                    :placeholder="email"
                                    class="mb-2"
                                    style="color: black"
                      ></b-form-input>

                        <label for="haushaltsstelle" v-if="!hasExternalKonto || isBauhof">Konto</label>
                        <b-form-input id="haushaltsstelle" type="text"
                                      v-model="hh"
                                      disabled
                                      :placeholder="hh"
                                      class="mb-2"
                                      v-if="!hasExternalKonto || isBauhof"
                        ></b-form-input>
                        <b-alert class="m-2" variant="danger" :show="showHhError" dismissible><p>Zu diesem Auftrag wurde noch kein Abrechnungskonto hinterlegt. Bitte wählen Sie ein abweichendes Konto aus oder geben Sie die Kontonummer für diesen Auftrag an.</p></b-alert>
                        <label v-if="!hasExternalKonto  || isBauhof" for="abweichend">Abweichendes Konto auswählen</label>
                        <!--b-form-select :options="a_select" id="abweichend" :plain="true"
                                       v-model="abweichend"
                                       class="mb-2 text-black"></--b-form-select-->
                        <vue-select :options="a_select" id="abweichend" label="text"
                                       v-model="abweichend"
                                       class="mb-2 text-black"
                                  v-if="!hasExternalKonto || isBauhof">
                            <template v-slot:option="option">
                                <b-row>
                                    <b-col>
                                        <span><b>{{option.value.hh}}</b></span>
                                    </b-col>
                                    <b-col>
                                        <span> {{ option.value.name }}</span>
                                    </b-col>
                                </b-row>
                            </template>
                        </vue-select>
                        <label class="mt-2" for="hh_alt" v-if="!hasExternalKonto || isBauhof">Abweichendes Konto eingeben</label>
                        <b-form-input id="hh_alt" type="text"
                                      v-model="hh_alt"
                                      :placeholder="settings.mask_new"
                                      class="mb-2"
                                      v-if="!hasExternalKonto || isBauhof"
                        ></b-form-input>
                        <p v-if="settings.mask_new !== '' && (!hasExternalKonto || isBauhof)">
                            <span>Ihr Kontoformat ist: <b>{{settings.mask_new}}</b></span>
                            <br>
                            <br>
                            <span>Formatbeschreibung:</span><br>
                            <span><b>9</b>: eine Ziffer</span><br>
                            <span><b>Z</b>: ein Buchstabe</span><br>
                            <span>Sonderzeichen müssen beibehalten werden.</span>
                        </p>
                      <label v-if="hasExternalKonto" for="konto_ext">Verrechnungskonto</label>
                      <b-form-input v-if="hasExternalKonto" id="konto_ext" type="text"
                                    v-model="externalKonto"
                                    :placeholder="externalKonto"
                                    class="mb-2"
                      ></b-form-input>
                        <b-form-group v-if="settings.hh_sk || settings.hh_invest">
                            <b-form-checkbox-group style="font-size: 1rem" v-on:input="shiftData" id="radio-typ"
                                                   v-model="typ" name="radio-typ">
                                <b-form-checkbox value="Unterhalts-Auftrag" v-if="settings.hh_invest">Unterhalts-Auftrag</b-form-checkbox>
                                <b-form-checkbox value="Investitions-Auftrag" v-if="settings.hh_sk">Investitions-Auftrag</b-form-checkbox>
                            </b-form-checkbox-group>
                        </b-form-group>
                        <div v-if="typ.length === 1 && (typ[0]=== 'Unterhalts-Auftrag' || typ[0]=== 'Investitions-Auftrag')">
                            <label for="sachkonto">Sachkonto</label>
                            <b-form-input id="sachkonto" type="text"
                                          v-model="sachkonto"
                                          placeholder=""
                                          class="mb-2"
                            ></b-form-input>
                        </div>
                        <div v-if="typ.length === 1 && typ[0]=== 'Investitions-Auftrag'">
                            <label for="projekt_auftrag">Projekt/Auftrag</label>
                            <b-form-input id="projekt_auftrag" type="text"
                                          v-model="projekt_auftrag"
                                          placeholder=""
                                          class="mb-2"
                            ></b-form-input>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <div  v-if="isExtern">
                <b-row class="justify-content-md-center">
                    <b-col lg="6" md="6" sm="10" style="    padding: 40px;
    background: #FBFBFB;
    border-radius: 20px;
    border: 1px solid #F0F0F0;">
                        <h5>Rechnungsempfänger</h5>
                        <b-form-group label="Typ">
                            <b-form-radio-group style="font-size: 1rem" id="radio-typ"
                                                   v-model="external.typ" name="radio-typ" v-on:change="changeSelects">
                                <b-form-radio value="Person">Person</b-form-radio>
                                <b-form-radio value="Firma">Firma</b-form-radio>
                            </b-form-radio-group>
                        </b-form-group>
                        <b-row>
                            <b-col sm="4">
                                <label for="anrede">Anrede</label>
                                <b-form-select :options="external.anrede_select" id="anrede" :plain="true"
                                               v-model="external.anrede"
                                               class="mb-2 text-black"></b-form-select>
                            </b-col>
                            <b-col sm="8">
                                <label for="pk_nr">PK-Nr.</label>
                                <b-form-input id="pk_nr" type="text"
                                              v-model="external.pk"
                                              class="mb-2"
                                              maxlength="20"
                                ></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                        <label for="name">{{name_bez}}</label>
                        <b-form-input id="name" type="text"
                                      v-model="external.name"
                                      class="mb-2"
                                      maxlength="80"
                        ></b-form-input>
                            </b-col>
                            <b-col sm="4" v-if="external.typ==='Firma'">
                                <label for="zu_heanden">zu Händen</label>
                                <b-form-input id="zu_heanden" type="text"
                                              v-model="external.zu_haenden"
                                              class="mb-2"
                                              maxlength="80"
                                ></b-form-input>
                            </b-col>
                        </b-row>
                        <label for="str_hnr">Straße Hausnummer</label>
                        <b-form-input id="str_hnr" type="text"
                                      v-model="external.strasse_hnr"
                                      class="mb-2"
                                      maxlength="80"
                        ></b-form-input>
                        <b-row>
                            <b-col sm="2">
                                <label for="land">Ländercode</label>
                                <b-form-input id="land" type="text"
                                              v-model="external.land"
                                              class="mb-2"
                                              placeholder="z.B. DE"
                                              maxlength="3"
                                ></b-form-input>
                            </b-col>
                            <b-col sm="2">
                                <label for="plz">PLZ</label>
                                <b-form-input id="plz" type="text"
                                              v-model="external.plz"
                                              class="mb-2"
                                              maxlength="5"
                                ></b-form-input>
                            </b-col>
                            <b-col sm="8">
                                <label for="ort">Ort</label>
                                <b-form-input id="ort" type="text"
                                              v-model="external.ort"
                                              class="mb-2"
                                              maxlength="80"
                                ></b-form-input>
                            </b-col>
                        </b-row>
                        <h5 class="mt-3">Rechnungsdaten</h5>
                        <label for="hh_ein">Einnahmekonto</label>
                        <b-form-select :options="external.hh_select" id="hh_ein" :plain="true"
                                       v-model="external.hh"
                                       class="mb-2 text-black"></b-form-select>
                      <b-alert class="m-2" variant="danger" :show="showHhError" dismissible><p>Bitte wählen Sie ein Einnahmekonto für diesen Auftrag aus.</p></b-alert>

                      <!--label for="mwst">Mehrwertsteuersatz</label>
                      <b-form-select :options="external.mwst_select" id="mwst" :plain="true"
                                     v-model="external.mwst"
                                     class="mb-2 text-black"></b-form-select-->
                    </b-col>
                    <b-col md="6" v-if="false">
                        <h5>Rechnungsdaten</h5>
                        <label for="hh_ein">Haushalsstelle Einnahme</label>
                        <b-form-select :options="external.hh_select" id="hh_ein" :plain="true"
                                       v-model="external.hh"
                                       class="mb-2 text-black"></b-form-select>
                        <!--label for="mwst">Mehrwertsteuersatz</label>
                        <b-form-select :options="external.mwst_select" id="mwst" :plain="true"
                                       v-model="external.mwst"
                                       class="mb-2 text-black"></b-form-select-->
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </div>
</template>

<script>
    import {Redirect_500, Redirect_Login, Server_URL} from "../../../shared/utils";
    import {decryptAES} from "@/shared/crypto";

    export default {
        name: "task_step3",
        props: ['currentStep'],
        created() {

        },
        mounted() {
            this.selected_augr = this.currentStep.payload.selected_augr;
            this.selected_aufisn = this.currentStep.payload.selected_aufisn;
            this.settings = this.currentStep.payload.settings;
            if (this.currentStep.payload.isBauhof) {
              this.isBauhof = true;
            }
            if (this.isBauhof && ["8888810", "7678978", "1325846"].includes(this.$cookies.get("ps_customer_number"))) {
              this.hasExternalEmail = true;
            }
            if (!this.settings.no_extern) {
                this.isExtern = this.selected_augr.typ.startsWith("EX");
            } else {
                this.isExtern = false;
            }
            this.hh = this.selected_aufisn.gi_hh_aus;
          if (this.isExtern) {
            this.setReFromPayload();
          }
          if (this.hasExternalKonto) {
            this.externalKonto = "";
            for (let i = 0; i < this.externalKontos.length; i++) {
              if (this.externalKontos[i].id === this.selected_aufisn.gi_aufisn) {
                this.externalKonto = this.externalKontos[i].value_2;
                break
              }
            }
            if (!this.isBauhof) {
              this.$emit('can-continue', {value: true});
              return
            }
          }

            if ((this.hh === null || this.hh === "") && (this.external.hh === null || this.external.hh.hh === "")) {
                this.showHhError = true;
                this.$emit('can-continue', {value: false});
            } else {
                this.$emit('can-continue', {value: true});
            }
            if (!this.mountedOnce) {
              this.mountedOnce = true;
              this.showLoader();
              this.$http.get(
                  Server_URL + '/auftragsbuch/data/create/step3?aufisn=' + this.selected_aufisn.gi_aufisn
              ).then(this.responseOkGet, this.responseError);
            }
        },
        data() {
            return {
                loader: undefined,
                hh: "",
                hh_alt: "",
                abweichend: null,
                a_select: [],
                typ: [],
                sachkonto: "",
                projekt_auftrag: "",
                isExtern: false,
                isBauhof: false,
                external: {
                    typ: "Person",
                    anrede_person: ["Herr", "Frau"],
                    anrede_firma: ["Firma", "An den", "An die", "An das", "Herr", "Frau"],
                    anrede_select: ["Firma", "An den", "An die", "An das", "Herr", "Frau"],
                    anrede: "Herr",
                    pk: '',
                    name: "",
                    zu_haenden: "",
                    strasse_hnr: "",
                    land: "",
                    plz: "",
                    ort: "",
                    hh_select: [],
                    hh: null,
                    mwst_select: [],
                    mwst: ""
                },


                selected_augr: {},
                selected_aufisn: {},
                settings: {
                    hh_invest: false,
                    hh_sk: false,
                },
                showHhError: false,
              hasExternalKonto: false,
              externalKontos: [],
              externalKonto: "",
              hasExternalEmail: false,
              email: "",
              mountedOnce: false,
            }
        },
        computed: {
            name_bez: function () {
                if (this.external.typ === "Firma")  {
                    return "Firmenname";
                } else {
                    return "Name"
                }
            },
          externalChanges() {
            return this.external.hh;
          }
        },
        watch: {
            hh_alt: function(newVal, oldVal) { // watch it
                 this.checkHh();
            },
            abweichend: function(newVal, oldVal) { // watch it
                this.checkHh();
            },
          externalChanges: function(newVal, oldVal) { // watch it
            this.checkHh();
          },
        },
        methods: {
            checkHh() {
              if(this.hasExternalKonto && !this.isBauhof) {
                if (this.$emit) {
                  this.$emit('can-continue', {value: true});
                }
                return;
              }
                if ((
                    (this.hh === null || this.hh === "") &&
                    (this.external.hh === null || this.external.hh.hh === "")) &&
                    (this.abweichend === null) &&
                    (this.hh_alt === "")
                    || !this.$emit) {
                  this.showHhError = true;
                  return
                }
                if (this.external.hh !== null && this.external.hh.hh !== "") {
                  this.showHhError = false;
                  this.$emit('can-continue', {value: true});
                  return;
                }
                if (this.abweichend !== null) {
                  this.showHhError = false;
                  this.$emit('can-continue', {value: true});
                    return;
                } else if (this.settings.mask_new === "" && this.hh_alt !== "") {
                  this.showHhError = false;
                  this.$emit('can-continue', {value: true});
                    return;
                } else if (this.hh_alt !== "") {
                    if (this.buildRegex().test(this.hh_alt)) {
                      this.showHhError = false;
                      this.$emit('can-continue', {value: true});
                    } else {
                      this.showHhError = true;
                      this.$emit('can-continue', {value: false});
                    }
                } else {
                  this.showHhError = true;
                  this.$emit('can-continue', {value: false});
                }
            },
          setReFromPayload() {
            if (this.currentStep.payload.re) {
              this.external.anrede = this.currentStep.payload.re.re_anrede;
              this.external.name = this.currentStep.payload.re.re_vorname;
              this.external.zu_haenden = this.currentStep.payload.re.re_name1;
              this.external.strasse_hnr = this.currentStep.payload.re.re_str_hnr;
              this.external.land = this.currentStep.payload.re.re_land;
              this.external.plz = this.currentStep.payload.re.re_plz;
              this.external.ort = this.currentStep.payload.re.re_ort;
              this.external.pk = this.currentStep.payload.re.renr;
            }
          },
            buildRegex() {
              let reg = "^";
                for (let i = 0; i < this.settings.mask_new.length; i++) {
                    let current = this.settings.mask_new[i];
                    if (current === "9") {
                        reg += "\\d{1}"
                    } else if (current === "Z") {
                        reg += "[A-Za-z]{1}"
                    } else {
                        reg += "["+current+"]{1}"
                    }
                }
                reg += "$"
                return new RegExp(reg);
            },
            shiftData(data) {
                if (data.length === 2) {
                    this.typ.shift();
                }
            },
            changeSelects(checked) {
                if (checked === "Person"){
                    this.external.anrede_select = this.external.anrede_person;
                    this.external.anrede = this.external.anrede_person[0];
                    this.external.zu_haenden = "";
                } else {
                    this.external.anrede_select = this.external.anrede_firma;
                    this.external.anrede = this.external.anrede_firma[0];
                }
            },
            setActive: function (payload) {
                if (this.selected_augr.key !== payload.selected_augr.key
                    || this.selected_aufisn.gi_aufisn !== payload.selected_aufisn.gi_aufisn) {
                    this.selected_augr = payload.selected_augr;
                    this.selected_aufisn = payload.selected_aufisn;
                    this.settings = payload.settings;
                    if (!this.settings.no_extern) {
                        this.isExtern = this.selected_augr.typ.startsWith("EX");
                    } else {
                        this.isExtern = false;
                    }
                    this.hh = this.selected_aufisn.gi_hh_aus;
                    this.abweichend = null;
                    if (this.hasExternalKonto) {
                      this.externalKonto = "";
                      for (let i = 0; i < this.externalKontos.length; i++) {
                        if (this.externalKontos[i].id === this.selected_aufisn.gi_aufisn) {
                          this.externalKonto = this.externalKontos[i].value_2;
                          break
                        }
                      }
                    }
                    // reset external
                  this.external.typ = "Firma"
                  this.external.anrede = "Firma"
                  this.external.pk = ""
                  this.external.name = ""
                  this.external.zu_haenden = ""
                  this.external.strasse_hnr = ""
                  this.external.land = ""
                  this.external.plz = ""
                  this.external.ort = ""
                  this.external.hh = {}
                }

              if (this.isExtern) {
                this.setReFromPayload();
              }
              if(this.hasExternalKonto && !this.isBauhof) {
                if (this.$emit) {
                  this.$emit('can-continue', {value: true});
                }
                return;
              }

                if (this.$emit) {
                  if ((this.hh === null || this.hh === "") && (this.external.hh === null || this.external.hh.hh === "")) {
                        this.showHhError = true;
                        this.$emit('can-continue', {value: false});
                    } else {
                        this.$emit('can-continue', {value: true});
                    }
                }
            },
            getReturnData: function () {
                let resHH = this.selected_aufisn.gi_hh_aus;
                if (resHH === null || resHH === "") {
                    if (this.abweichend === null || this.abweichend.value.hh === undefined) {
                        resHH = this.hh_alt;
                    } else {
                        resHH = this.abweichend.value.hh;
                    }
                } else {
                    if((this.abweichend === null || this.abweichend.value.hh === undefined) && this.hh_alt !== "") {
                        resHH = this.hh_alt;
                    } else if ((this.abweichend !== null && this.abweichend.value.hh !== undefined) &&  this.hh_alt === "") {
                        resHH = this.abweichend.value.hh;
                    } else if ((this.abweichend !== null && this.abweichend.value.hh !== undefined) &&  this.hh_alt !== "") {
                        resHH = this.abweichend.value.hh;
                    }
                }
                let externalData = null;
                if (this.isExtern) {
                  externalData = {
                    re_anrede: this.external.anrede,
                    re_vorname: this.external.name,
                    re_name1: this.external.zu_haenden,
                    re_str_hnr: this.external.strasse_hnr,
                    re_land: this.external.land,
                    re_plz: this.external.plz,
                    re_ort: this.external.ort,
                    renr: this.external.pk,
                    gi_hh_ein: this.external.hh !== null && this.external.hh.hh !== undefined ? this.external.hh.hh : "",
                  }
                }
                return {
                    hh: resHH,
                    konto_external: this.externalKonto,
                    external: externalData,
                    email: this.email,
                };
            },
            showLoader() {
                this.loader = this.$loading.show();
            },
            hideLoader() {
                if (this.loader !== undefined) {
                    this.loader.hide();
                    this.loader = undefined;
                }
            },
            async responseOkGet(response) {
                this.hideLoader();
                if (response.status === 200 && response.body.status === "ok") {
                  let hhs = response.body.data.hhs;
                  this.hasExternalKonto = response.body.data.has_external_konto;
                  this.externalKontos = response.body.data.external_kontos;
                  if (response.body.data.possible_email !== "") {
                    // decrypt email
                    this.email = await decryptAES(sessionStorage.getItem("aes"), response.body.data.possible_email);
                  }
                  for (let i = 0; i < hhs.length; i++) {
                        this.a_select.push({
                            text: hhs[i].hh + "   " + hhs[i].name,
                            value: hhs[i],
                        });
                    }
                    this.a_select.sort(function (a, b) {
                        return ('' + a.value.name).localeCompare(b.value.name);
                    })
                  for (let i = 0; i < this.a_select.length; i++) {
                    if (this.a_select[i].typ !== 'A') {
                      this.external.hh_select.push(this.a_select[i])
                    }
                  }
                  if (this.hasExternalKonto && this.externalKonto === '') {
                    for (let i = 0; i < this.externalKontos.length; i++) {
                      if (this.externalKontos[i].id === this.selected_aufisn.gi_aufisn) {
                        this.externalKonto = this.externalKontos[i].value_2;
                        break
                      }
                    }
                  }
                } else {
                    window.location = Redirect_500;
                }
            },
            responseError(response) {
                this.hideLoader();
                if (response.status === 401) {
                    window.location = Redirect_Login;
                } else {
                    window.location = Redirect_500;
                }
            },
        }
    }
</script>

<style scoped>
    .form-control:disabled {
        color: black;
    }

    .text-black {
        color: black;
    }
</style>

